import { sendFindingsMailResponseSchema, } from '../..';
import { createTransformer, mapToSnakeCase } from './shared/base-api';
export const notificationApiEndpoints = (builder, coreApiBaseUrl) => ({
    notifyPublishedDocumentPackage: builder.mutation({
        query: ({ packageId, projectId, language, emailRecipient, message }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/notify/`,
            method: 'POST',
            body: mapToSnakeCase({ language, emailRecipient, message }),
        }),
    }),
    notifyPublishedLayoutOptimization: builder.mutation({
        query: ({ projectId, layoutId, language, emailRecipient, message }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/layout-optimizations/${layoutId}/notify/`,
            method: 'POST',
            body: mapToSnakeCase({
                language,
                emailRecipient,
                message,
            }),
        }),
    }),
    sendFindingsMail: builder.mutation({
        query: ({ projectId, packageId, findingsMail }) => {
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/findings/forward/`,
                method: 'POST',
                body: mapToSnakeCase(findingsMail),
            };
        },
        transformResponse: createTransformer(sendFindingsMailResponseSchema, 'SendFindingsMail'),
    }),
});
